import axios from "axios";
const apiUrl = process.env.REACT_APP_API_URL + "meta/";

export const closeFBMessage = async (payload) => {
  try {
    const config = {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    };

    const response = await axios.post(
      `${apiUrl}closefbmessage`,
      payload,
      config
    );
    return response.data;
  } catch (error) {
    return {
      status: false,

      error:
        "API closeFBMessage: " +
        (error.response && error.response.data
          ? error.response.data.error
          : error.message
          ? error.message
          : "Failed!"),
    };
  }
};

export const getFacebookMessage = async (
  conversationID,
  page,
  isNewMessage,
  sessionNo = "",
) => {
  try {
    const config = {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    };

    const response = await axios.get(
      `${apiUrl}getfacebookmessage?conversationid=${conversationID}&page=${page}&limit=${
        // isNewMessage ? 1 : 20
        9999
      }&session_no=${sessionNo}`,
      config
    );

    return response.data;
  } catch (error) {
    return {
      status: false,

      error:
        "API getFacebookMessage: " +
        (error.response && error.response.data
          ? error.response.data.error
          : error.message
          ? error.message
          : "Failed!"),
    };
  }
};

export const getFacebookMessageHistory = async (conversationID, pagesID) => {
  try {
    const config = {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    };

    const response = await axios.get(
      `${apiUrl}getfacebookmessagehistory?conversationid=${conversationID}&pagesid=${pagesID}`,
      config
    );

    return response.data;
  } catch (error) {
    return {
      status: false,

      error:
        "API getFacebookMessageHistory: " +
        (error.response && error.response.data
          ? error.response.data.error
          : error.message
            ? error.message
            : "Failed!"),
    };
  }
};

export const getFBChatInfo = async (chatListID) => {
  try {
    const config = {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    };

    const response = await axios.get(
      `${apiUrl}getfbchatinfo?chatlistid=${chatListID}`,
      config
    );

    return response.data;
  } catch (error) {
    return {
      status: false,

      error:
        "API getFBChatInfo: " +
        (error.response && error.response.data
          ? error.response.data.error
          : error.message
            ? error.message
            : "Failed!"),
    };
  }
};

export const MetaManualAssignAgent = async (payload) => {
  try {
    const config = {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    };

    const response = await axios.post(
      `${apiUrl}manualassignagent`,
      payload,
      config
    );

    return response.data;
  } catch (error) {
    return {
      status: false,

      error:
        "API MetaManualAssignAgent: " +
        (error.response && error.response.data
          ? error.response.data.error
          : error.message
          ? error.message
          : "Failed!"),
    };
  }
};

export const postFacebookMessage = async (payload) => {
  try {
    const config = {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    };

    const response = await axios.post(
      `${apiUrl}postfacebookmessage`,
      payload,
      config
    );
    return response.data;
  } catch (error) {
    return {
      status: false,

      error:
        "API postFacebookMessage: " +
        (error.response && error.response.data
          ? error.response.data.error
          : error.message
          ? error.message
          : "Failed!"),
    };
  }
};
